import {phoneNumber} from "../../util/formatter";

export default function ErrorMessage() {
    return (
        <div className="selfcare-page-content selfcare-page-error">
            <h1 className="heading heading--big heading">Hov, der er desværre sket en fejl</h1>
            <p>
                Du kan prøve at <button className='selfcare-button-link' onClick={() => window.location.reload()}>genindlæse</button> siden. {" "}
                Ellers vil vi meget gerne hjælpe dig, så kontakt os venligst på {" "}
                <a href="tel:+4588772000">{phoneNumber('88772000')}</a>.
            </p>
        </div>
    )
}
